import * as ROLES           from 'AppConfig/Config';
import { Store }            from 'Redux/Config';
import { userContainsRole } from 'Redux/Query';

export const Has = (Roles) => {
  const state = Store.getState();
  const checkUserRole = userContainsRole(state);

  const _roles = Roles.filter((role) => ROLES[role]).map(role => ROLES[role]);

  return checkUserRole(_roles);
};
